// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export default {
  apiKey: 'AIzaSyBk8WqMELo0Eyv4Sqxb1rVioW2HqHDtef8',
  authDomain: 'project-fo.firebaseapp.com',
  databaseURL: 'https://project-fo.firebaseio.com',
  projectId: 'project-fo',
  storageBucket: 'project-fo.appspot.com',
  messagingSenderId: '508568918227',
  appId: '1:508568918227:web:e441d13806c93a34cadc26',
  measurementId: 'G-ZBMKKETS3X',
}
